import * as React from 'react'
import { RD, O, pipe } from '@packages/prelude'
import * as domain from '@packages/domain'
import type { SubmissionResult } from './PurchaseForm'
import { FormSubmit } from './FormSubmit'
import { Checkbox } from './Checkbox'
import { OrderSummary } from './OrderSummary'
import { react } from '~/commons'
import { Price as priceUtils } from '~/utils'

interface OrderProps {
  submissionState: RD.RemoteData<Error, SubmissionResult>
  handleBack: () => void
  price: number
}

export const Order: React.FC<OrderProps> = ({ submissionState, handleBack, price }) => {
  const [paymentType, setPaymentType] = React.useState<O.Option<domain.PaymentType.Type>>(O.none)

  const prices = React.useMemo(() => priceUtils.mkPrices(price), [price])

  const handlePaymentTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    pipe(event.target.value, domain.PaymentType.Type.decode, O.fromEither, setPaymentType)
  }

  return (
    <FormSubmit
      title="Ihre Bestellung"
      submissionType="order"
      submissionState={submissionState}
      handleBack={handleBack}
      submitButtonText="Jetzt kaufen">
      <Checkbox
        type="radio"
        id="payment-amount-50"
        name="payment_type"
        value="partial"
        required
        label={`Ich möchte eine Anzahlung (${window.htcConfig.payment.down_payment_percentage}%) i.H.v. € ${prices.partial.label} leisten.`}
        className="my-4"
        onChange={handlePaymentTypeChange}
      />
      <Checkbox
        type="radio"
        id="payment-amount-100"
        name="payment_type"
        value="full"
        required
        label={`Ich möchte den Gesamtbetrag i.H.v. € ${prices.full.label} jetzt bezahlen (abzgl. ${window.htcConfig.payment.skonto_percentage}% Skonto).`}
        className="my-4"
        onChange={handlePaymentTypeChange}
      />

      <Checkbox
        type="checkbox"
        id="revocation"
        required
        label="Ich bestätige, dass ich ein individuell konfiguriertes Produkt bestelle und mir bekannt ist, dass bei solchen Produkten gemäß § 312g Abs. 2 Nr. 1 BGB kein Widerrufsrecht besteht."
        className="my-4"
      />

      {pipe(
        paymentType,
        O.foldMap(react.monoid)(paymentType => <OrderSummary paymentType={paymentType} prices={prices} />)
      )}
    </FormSubmit>
  )
}
